module.exports = __webpack_public_path__ + "img/jy1.370cfe3c.png";